import { createContext } from "react";
import { UseFormMethods } from "react-hook-form";

import { GetFileRecordDetailsResponse } from "../../../../../../common/api/master-api/file-records/details/GetFileRecordDetailsResponse";
import { RecordType } from "../../../../../../common/types/RecordType";
import { StorageType } from "../../../../../../common/types/StorageType";
import { CreateFileRecordFormInputs } from "../../CreateFileRecordFormInputs";

export interface ICreateFileRecordStateContext {
    sourceFileRecord?: GetFileRecordDetailsResponse;
    setSourceFileRecord(fileRecord?: GetFileRecordDetailsResponse): void;

    selectedRecordType?: RecordType;
    setSelectedRecordType(recordType: RecordType): void;

    selectedStorageType?: StorageType;
    setSelectedStorageType(storageType: StorageType): void;

    isLoading: boolean;
    setIsLoading(isLoading: boolean): void;

    form: UseFormMethods<CreateFileRecordFormInputs>;
}

const defaultCreateFileRecordStateContext = {} as ICreateFileRecordStateContext;

export const CreateFileRecordStateContext = createContext<ICreateFileRecordStateContext>(
    defaultCreateFileRecordStateContext
);
